// tslint:disable:trailing-comma

class Params<T> {
  private prarms?: T;

  /**
   * 设置参数（通过参数通道获取）
   * @param prarms 参数
   */
  setParams(prarms: T) {
    this.prarms = prarms;
  }

  /**
   * 获取参数
   * @returns 参数
   */
  getParams(): T | undefined {
    return this.prarms && { ...this.prarms };
  }
}

export default new Params<any>();
